var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"parent"},[_c('div',{staticClass:"child text-center"},[_c('div',{staticClass:"text-404"},[_c('span',{staticClass:"text"},[_vm._v("4")]),_c('i',{staticClass:"fas fa-meh icon-style fa-spin m-l-10 m-r-10"}),_c('span',{staticClass:"text"},[_vm._v("4")])]),_c('div',{staticClass:"text-not-found"},[_vm._v("Page Not Found")])])])
}]

export { render, staticRenderFns }